var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-group mb-3",class:_vm.mainClass},[_c('div',{staticClass:"label-class text-info"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"slot-wrapper text-break"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }